import { ApiService } from './apiService';

// ─── Types ───────────────────────────────────────────────────────────────────

export interface ProductChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  createdAt: string;
}

// Where one conversation lives: `products/:productId/chat` for a product, which
// the server settles on a store product for, or `store-products/:id/chat`.
export interface SendProductChatMessagePayload {
  chatUrl: string;
  message: string;
}

export interface ListProductChatMessagesDto {
  chatUrl: string;
  page: number;
  size: number;
}

// ─── Service ─────────────────────────────────────────────────────────────────

// Sila over one product, as a shopper would ask her. Messages come back newest
// first.
export const getProductChatMessages = async (dto: ListProductChatMessagesDto): Promise<ProductChatMessage[]> => {
  return await ApiService.get(`${dto.chatUrl}?page=${dto.page}&size=${dto.size}`);
};

export const sendProductChatMessage = async (payload: SendProductChatMessagePayload): Promise<string> => {
  const result: { responseText: string } = await ApiService.post(
    payload.chatUrl,
    { message: payload.message },
  );
  return result.responseText;
};

export const clearProductChat = async (chatUrl: string) => {
  return await ApiService.delete(chatUrl);
};
